/* =====================================================================
   AVERN PARIS — theme script
   Vanilla JS. Lenis (smooth scroll) and GSAP + ScrollTrigger (parallax) are
   progressive enhancements: every feature below still works without them.
   ===================================================================== */
(function () {
  "use strict";

  var A = window.AVERN || { routes: {}, strings: {} };
  var body = document.body;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Scroll engine (Lenis) + scroll lock ---------- */
  var lenis = null;
  var lockCount = 0;

  function initSmoothScroll() {
    if (lenis || reduceMotion || body.dataset.smooth !== "true" || typeof window.Lenis === "undefined") return;
    // Touch devices already scroll natively with inertia; Lenis smooths wheel and keyboard input.
    lenis = new window.Lenis({ duration: 1.15, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      lenis.on("scroll", window.ScrollTrigger.update);
      window.gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      window.gsap.ticker.lagSmoothing(0);
    } else {
      (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(0);
    }
  }

  function lockScroll(on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    var locked = lockCount > 0;
    body.classList.toggle("is-locked", locked);
    if (lenis) { locked ? lenis.stop() : lenis.start(); }
  }

  function scrollToTarget(el) {
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" });
  }

  /* ---------- Focus trap ---------- */
  function trapFocus(container, e) {
    if (e.key !== "Tab") return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]), select, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Header state ---------- */
  var searchOpen = false;
  function refreshHeader() {
    var header = $("[data-header]");
    if (!header) return;
    if (!header.classList.contains("is-overlay")) return;
    var hero = $(".hero");
    var past = hero ? hero.getBoundingClientRect().bottom <= header.offsetHeight : true;
    header.classList.toggle("is-solid", past || searchOpen || $("#menu.is-open") !== null);
  }

  /* ---------- Side menu, search panel (delegated: survives theme-editor re-renders) ---------- */
  function syncScrim() {
    var scrim = $("#scrim");
    if (scrim) scrim.classList.toggle("is-visible", !!$("#menu.is-open, #search.is-open, #cart.is-open, #filters.is-open"));
  }

  var menuFocus = null;
  function setMenu(open) {
    var menu = $("#menu");
    if (!menu || open === menu.classList.contains("is-open")) return;
    if (open) { setSearch(false, true); setCart(false, true); }
    var btn = $("[data-menu-open]");
    menu.classList.toggle("is-open", open);
    menu.setAttribute("aria-hidden", String(!open));
    if (btn) btn.setAttribute("aria-expanded", String(open));
    lockScroll(open);
    syncScrim();
    refreshHeader();
    if (open) { menuFocus = document.activeElement; var c = $("[data-menu-close]"); if (c) c.focus(); }
    else if (menuFocus && !arguments[1]) { menuFocus.focus(); }
  }

  var searchFocus = null, searchTimer = null, searchCtl = null;
  function setSearch(open) {
    var search = $("#search");
    if (!search || open === search.classList.contains("is-open")) return;
    if (open) { setMenu(false, true); setCart(false, true); }
    searchOpen = open;
    search.classList.toggle("is-open", open);
    search.setAttribute("aria-hidden", String(!open));
    lockScroll(open);
    syncScrim();
    refreshHeader();
    if (open) {
      searchFocus = document.activeElement;
      setTimeout(function () { var i = $("[data-search-input]", search); if (i) { i.focus(); i.select(); } }, 220);
      var cur = $("[data-search-input]", search);
      if (cur && cur.value.trim().length > 1) runSearch(cur.value.trim());
    } else if (searchFocus && !arguments[1]) { searchFocus.focus(); }
  }

  function formatPrice(str) {
    var n = parseFloat(str);
    if (isNaN(n)) return str;
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "INR";
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(n); }
    catch (err) { return n.toFixed(0); }
  }

  // Live product results from Shopify's predictive search endpoint. Built with DOM APIs, never innerHTML.
  function runSearch(q) {
    var res = $("[data-search-results]"), grid = $("[data-search-grid]"), empty = $("[data-search-empty]"),
        all = $("[data-search-all]"), pop = $("[data-search-popular]");
    if (!res) return;
    if (q.length < 2) { res.hidden = true; empty.hidden = true; if (pop) pop.hidden = false; return; }
    if (searchCtl && searchCtl.abort) searchCtl.abort();
    searchCtl = "AbortController" in window ? new AbortController() : null;
    var url = A.routes.search + "/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last";
    fetch(url, searchCtl ? { signal: searchCtl.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var items = (j.resources && j.resources.results && j.resources.results.products) || [];
        grid.textContent = "";
        if (pop) pop.hidden = true;
        all.href = A.routes.search + "?q=" + encodeURIComponent(q) + "&type=product";
        if (!items.length) { res.hidden = true; empty.hidden = false; return; }
        empty.hidden = true;
        items.forEach(function (p, i) {
          var a = document.createElement("a");
          a.className = "search__item"; a.href = p.url; a.style.setProperty("--n", i);
          var m = document.createElement("div"); m.className = "media media--zoom";
          if (p.image) {
            var im = document.createElement("img");
            try { var u = new URL(p.image, location.href); u.searchParams.set("width", "420"); im.src = u.toString(); } catch (err) { im.src = p.image; }
            im.alt = ""; im.loading = "lazy"; im.width = 420; im.height = 525;
            m.appendChild(im);
          }
          var n = document.createElement("span"); n.className = "search__item-name"; n.textContent = p.title;
          var pr = document.createElement("span"); pr.className = "search__item-price"; pr.textContent = formatPrice(p.price);
          a.appendChild(m); a.appendChild(n); a.appendChild(pr);
          grid.appendChild(a);
        });
        res.hidden = false;
      })
      .catch(function (err) { if (err && err.name === "AbortError") return; res.hidden = true; });
  }

  /* ---------- Cart ---------- */
  var cartFocus = null;
  var toastTimer;

  function toast(msg) {
    var t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("is-visible"); }, 2400);
  }

  function setCart(open) {
    var cart = $("#cart");
    if (!cart || open === cart.classList.contains("is-open")) return;
    if (open) { setMenu(false, true); setSearch(false, true); }
    cart.classList.toggle("is-open", open);
    cart.setAttribute("aria-hidden", String(!open));
    lockScroll(open);
    syncScrim();
    if (open) { cartFocus = document.activeElement; var c = $("[data-cart-close]", cart); if (c) c.focus(); }
    else if (cartFocus && !arguments[1]) { cartFocus.focus(); }
  }

  function updateCount(n) {
    $$("[data-cart-count]").forEach(function (b) {
      var prev = parseInt(b.textContent, 10) || 0;
      b.textContent = n;
      b.classList.toggle("is-visible", n > 0);
      if (n > prev && !reduceMotion) {
        b.classList.remove("is-bump");
        void b.offsetWidth;
        b.classList.add("is-bump");
      }
    });
  }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || A.strings.error); e.data = j; throw e; } return j; });
    });
  }

  function refreshCart() {
    return Promise.all([
      fetchJSON(A.routes.root + "?sections=cart-drawer"),
      fetchJSON(A.routes.cart + ".js")
    ]).then(function (res) {
      var doc = new DOMParser().parseFromString(res[0]["cart-drawer"], "text/html");
      var next = $("#cart", doc), cur = $("#cart");
      if (next && cur) { cur.innerHTML = next.innerHTML; }
      updateCount(res[1].item_count);
    });
  }

  function addToCart(id, qty) {
    return fetchJSON(A.routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(refreshCart).then(function () { setCart(true); });
  }

  function changeLine(line, qty) {
    return fetchJSON(A.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    });
  }

  function onCartLineAction(target) {
    var row = target.closest(".cart-item");
    if (!row) return false;
    var line = row.dataset.line;
    var qtyEl = $(".qty span", row);
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var next = null;
    if (target.closest("[data-line-remove]")) next = 0;
    var step = target.closest("[data-qty-step]");
    if (step) next = Math.max(0, current + Number(step.dataset.qtyStep));
    if (next === null) return false;
    row.classList.add("is-busy");
    changeLine(line, next).then(function () {
      if ($("[data-cart-page]")) { window.location.reload(); return; }
      return refreshCart();
    }).catch(function (e) { row.classList.remove("is-busy"); toast(e.message); });
    return true;
  }

  /* ---------- Carousels ---------- */
  function initCarousels(root) {
    $$("[data-carousel]", root).forEach(function (track) {
      if (track.dataset.bound) return;
      track.dataset.bound = "1";
      var scope = track.closest("section") || document;
      var prev = $("[data-carousel-prev]", scope), next = $("[data-carousel-next]", scope);
      if (!prev || !next) return;
      function step() {
        var first = track.firstElementChild;
        if (!first) return 0;
        var cs = getComputedStyle(track);
        return first.getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 0);
      }
      function update() {
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      }
      prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
      next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* ---------- Swipe carousel with dot indicators (reviews) ---------- */
  function initDots(root) {
    $$("[data-dots-carousel]", root).forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = "1";
      var track = $("[data-dots-track]", wrap), dotsEl = $("[data-dots]", wrap);
      var prev = $("[data-dots-prev]", wrap), next = $("[data-dots-next]", wrap);
      if (!track || !dotsEl) return;
      var slides = Array.prototype.slice.call(track.children);
      var dots = slides.map(function (s, i) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "dots__dot"; b.setAttribute("aria-label", "Go to review " + (i + 1));
        b.addEventListener("click", function () { go(i); });
        dotsEl.appendChild(b);
        return b;
      });
      function go(i) { track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduceMotion ? "auto" : "smooth" }); }
      function current() {
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 2) return slides.length - 1;
        var best = 0, bestD = Infinity;
        slides.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - slides[0].offsetLeft - track.scrollLeft); if (d < bestD) { bestD = d; best = i; } });
        return best;
      }
      function update() {
        var c = current();
        dots.forEach(function (d, i) { d.classList.toggle("is-on", i === c); if (i === c) d.setAttribute("aria-current", "true"); else d.removeAttribute("aria-current"); });
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      }
      if (prev) prev.addEventListener("click", function () { go(Math.max(0, current() - 1)); });
      if (next) next.addEventListener("click", function () { go(Math.min(slides.length - 1, current() + 1)); });
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* The new-collection card steps aside while a menu dropdown is open, so the dropdown has the room. */
  function syncMenuState() {
    var m = $("#menu");
    if (!m) return;
    m.classList.toggle("has-open", !!m.querySelector("details.menu__group[open]:not(.is-closing)"));
  }

  /* ---------- Smooth dropdowns: the box visibly opens and closes ---------- */
  var EASE_OPEN = "cubic-bezier(0.22, 1, 0.36, 1)";
  function toggleDetails(d) {
    var body = d.querySelector(".acc__body, .menu__sub, .footer__policies-list");
    if (!body || reduceMotion || !body.animate) { d.open = !d.open; return; }
    if (d._anim) { d._anim.cancel(); d._anim = null; body.style.overflow = ""; }
    var cs = getComputedStyle(body);
    var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var opening = !d.open || d.classList.contains("is-closing");
    function frame(h, p, o) { return { height: h + "px", paddingTop: p ? pt + "px" : "0px", paddingBottom: p ? pb + "px" : "0px", opacity: o }; }
    function full() { return cs.boxSizing === "border-box" ? body.offsetHeight : body.offsetHeight - pt - pb; }
    body.style.overflow = "hidden";
    if (opening) {
      d.classList.remove("is-closing");
      d.open = true;
      var to = full();
      d._anim = body.animate([frame(0, false, 0), frame(to, true, 1)], { duration: 620, easing: EASE_OPEN });
      d._anim.onfinish = d._anim.oncancel = function () { body.style.overflow = ""; d._anim = null; };
    } else {
      var from = full();
      d.classList.add("is-closing");
      d._anim = body.animate([frame(from, true, 1), frame(0, false, 0)], { duration: 420, easing: "cubic-bezier(0.65, 0, 0.35, 1)" });
      d._anim.onfinish = function () { d.open = false; d.classList.remove("is-closing"); body.style.overflow = ""; d._anim = null; };
      d._anim.oncancel = function () { body.style.overflow = ""; };
    }
  }
  document.addEventListener("click", function (e) {
    var s = e.target.closest && e.target.closest("details.acc > summary, details.menu__group > summary, details.footer__policies > summary");
    if (!s) return;
    e.preventDefault();
    toggleDetails(s.parentNode);
    syncMenuState();
  });

  /* ---------- Reveal on scroll ---------- */
  var io = null;
  // Product pages: every heading, line of text, icon and photo eases in as it scrolls into view.
  var PDP_REVEAL = [
    ".pdpx__title", ".pdpx__sub", ".pdpx__muted", ".pdpx__variants", ".styling-pair__item",
    ".promises__item", ".pack__carousel", ".reviews__summary", ".pdpx__faq .acc",
    ".recs .pdpx__row", ".recs__track", ".recs__all", ".pdp__acc .acc"
  ].join(",");
  function tagProductReveal(root) {
    if (!document.body.classList.contains("template-product")) return;
    $$(PDP_REVEAL, root).forEach(function (el) { el.classList.add("reveal"); });
  }

  function initReveal(root) {
    tagProductReveal(root);
    var els = $$(".reveal:not(.is-in)", root);
    if (!els.length) return;
    if (!("IntersectionObserver" in window) || reduceMotion) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          // Items that enter together (a row of cards) arrive one after another.
          if (!en.target.hasAttribute("data-delay")) en.target.style.transitionDelay = Math.min(n, 6) * 80 + "ms";
          n++;
          en.target.classList.add("is-in");
          io.unobserve(en.target);
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Parallax (GSAP ScrollTrigger) ---------- */
  function initParallax(root) {
    if (reduceMotion || body.dataset.parallax !== "true" || !window.gsap || !window.ScrollTrigger) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    var mm = window.gsap.matchMedia();
    mm.add("(min-width: 900px)", function () {
      $$("[data-parallax-img]", root).forEach(function (el) {
        if (el.dataset.px) return;
        el.dataset.px = "1";
        window.gsap.fromTo(el, { yPercent: -5 }, {
          yPercent: 5, ease: "none",
          scrollTrigger: { trigger: el.parentElement, start: "top bottom", end: "bottom top", scrub: true }
        });
      });
      var hero = $("[data-hero-media]", root);
      if (hero && !hero.dataset.px) {
        hero.dataset.px = "1";
        window.gsap.to(hero, { yPercent: 12, scale: 1.06, ease: "none",
          scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true } });
      }
    });
  }

  /* ---------- Hero intro ---------- */
  function initHeroIntro() {
    if (!$("[data-hero]")) { body.classList.add("is-ready"); return; }
    requestAnimationFrame(function () { requestAnimationFrame(function () { body.classList.add("is-ready"); }); });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    $$("[data-product]", root).forEach(function (pdp) {
      if (pdp.dataset.bound) return;
      pdp.dataset.bound = "1";
      var form = $("[data-product-form]", pdp) || $("form", pdp);
      var idInput = $("[data-variant-id]", pdp);
      var addBtn = $("[data-add-btn]", pdp);
      var label = $("[data-add-label]", pdp);
      var err = $("[data-form-error]", pdp);
      var priceEl = $("[data-price]", pdp);
      var dataEl = $("[data-variants]", pdp);
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var qtyInput = $("[data-pdp-qty-input]", pdp);

      function selectedOptions() {
        return $$(".opt", pdp).map(function (fs) {
          var c = $("input:checked", fs);
          return c ? c.value : null;
        });
      }

      var stockEl = $("[data-stock]", pdp);
      var bar = $("[data-sticky-bar]", pdp);
      var barBtn = bar ? $("[data-bar-btn]", bar) : null;
      var barPrice = bar ? $("[data-bar-price]", bar) : null;

      // Strike through option values that would lead to a sold-out variant.
      function markUnavailable() {
        var sel = selectedOptions();
        $$(".opt", pdp).forEach(function (fs, idx) {
          $$("input", fs).forEach(function (inp) {
            var test = sel.slice(); test[idx] = inp.value;
            var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return test[i] === null || o === test[i]; }); });
            var lab = fs.querySelector('label[for="' + inp.id + '"]');
            if (lab) lab.classList.toggle("is-unavailable", !ok);
          });
        });
      }

      function applyVariant() {
        var sel = selectedOptions();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return sel[i] === null || o === sel[i]; }); });
        markUnavailable();
        if (!v) {
          addBtn.disabled = true; label.textContent = A.strings.unavailable;
          if (barBtn) { barBtn.disabled = true; barBtn.textContent = A.strings.unavailable; }
          return;
        }
        idInput.value = v.id;
        addBtn.disabled = !v.available;
        var txt = v.available ? A.strings.add : A.strings.soldOut;
        label.textContent = txt;
        if (barBtn) { barBtn.disabled = !v.available; barBtn.textContent = txt; }
        var nowBtn = $("[data-buy-now]", pdp);
        if (nowBtn) nowBtn.disabled = !v.available;
        priceEl.innerHTML = (v.compare ? "<s>" + v.compare + "</s> " : "") + v.price;
        if (barPrice) barPrice.textContent = v.price;
        if (stockEl) {
          var st = $("[data-stock-text]", stockEl);
          stockEl.classList.toggle("is-out", !v.available);
          stockEl.classList.toggle("is-low", v.available && !!v.stock);
          stockEl.hidden = v.available && !v.stock;
          if (st) st.textContent = !v.available ? "Sold out" : (v.stock ? "Only " + v.stock + " left" : "");
        }
        $$(".opt", pdp).forEach(function (fs) {
          var cur = $("[data-opt-current]", fs), c = $("input:checked", fs);
          if (cur && c) cur.textContent = c.value;
        });
        $$(".vthumb").forEach(function (b) {
          b.classList.toggle("is-on", sel[0] !== null && b.dataset.value === sel[0]);
        });
        if (v.media && gallery) {
          var m = $('[data-media-id="' + v.media + '"]', pdp);
          if (m) gallery.scrollTo({ left: slides().indexOf(m) * gallery.clientWidth, behavior: "smooth" });
        }
        if (window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set("variant", v.id);
          window.history.replaceState({}, "", u.toString());
        }
      }

      // Gallery: counter, thumbnails and arrows stay in step with the swipe position.
      var gallery = $("[data-gallery]", pdp), thumbs = $$("[data-thumb]", pdp), counter = $("[data-gallery-index]", pdp);
      var prevBtn = $("[data-gal-prev]", pdp), nextBtn = $("[data-gal-next]", pdp);
      function slides() { return $$(".pdp__media", pdp); }
      function galIndex() { return Math.round(gallery.scrollLeft / (gallery.clientWidth || 1)); }
      function goTo(i) { gallery.scrollTo({ left: i * gallery.clientWidth, behavior: "smooth" }); }
      function syncGallery() {
        var i = galIndex(), n = slides().length;
        if (counter) counter.textContent = i + 1;
        var total = $("[data-gallery-total]", pdp);
        if (total) total.textContent = n;
        var single = n <= 1;
        $$(".pdp__thumbs, .pdp__arrow, .pdp__count", pdp).forEach(function (el) { el.hidden = single; });
        $$("[data-thumb]", pdp).forEach(function (t, k) {
          t.classList.toggle("is-on", k === i);
          if (k === i && t.parentElement) {
            var row = t.parentElement;
            row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: "smooth" });
          }
        });
        if (prevBtn) prevBtn.disabled = i <= 0;
        if (nextBtn) nextBtn.disabled = i >= n - 1;
      }
      if (gallery) {
        var galTimer;
        gallery.addEventListener("scroll", function () { clearTimeout(galTimer); galTimer = setTimeout(syncGallery, 60); }, { passive: true });
        thumbs.forEach(function (t) { t.addEventListener("click", function () { goTo(Number(t.dataset.thumb)); }); });
        if (prevBtn) prevBtn.addEventListener("click", function () { goTo(Math.max(0, galIndex() - 1)); });
        if (nextBtn) nextBtn.addEventListener("click", function () { goTo(Math.min(slides().length - 1, galIndex() + 1)); });
        syncGallery();
        pdp.addEventListener("gallery:refresh", syncGallery);
      }

      // Sticky add-to-bag bar: appears once the main button has scrolled out of view (mobile only, via CSS).
      // It steps away again once the footer is on screen, so it never covers the footer text.
      if (bar && "IntersectionObserver" in window) {
        var buyOut = false, footerShown = false;
        function syncBar() {
          var show = buyOut && !footerShown;
          bar.classList.toggle("is-visible", show);
          bar.setAttribute("aria-hidden", String(!show));
          if (barBtn) barBtn.tabIndex = show ? 0 : -1;
        }
        new IntersectionObserver(function (entries) {
          buyOut = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          syncBar();
        }).observe($(".pdp__buy", pdp));
        var footerEl = $(".footer");
        if (footerEl) {
          new IntersectionObserver(function (entries) {
            footerShown = entries[0].isIntersecting;
            syncBar();
          }).observe(footerEl);
        }
      }
      markUnavailable();

      pdp.addEventListener("change", function (e) { if (e.target.closest(".opt")) applyVariant(); });

      pdp.addEventListener("click", function (e) {
        var s = e.target.closest("[data-pdp-qty]");
        if (s) { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(s.dataset.pdpQty)); return; }
        var now = e.target.closest("[data-buy-now]");
        if (now && !now.disabled) {
          err.hidden = true;
          now.disabled = true;
          var txt = now.textContent;
          now.textContent = "Please wait";
          fetchJSON(A.routes.cartAdd + ".js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qtyInput.value) || 1 }] })
          }).then(function () { window.location.href = "/checkout"; })
            .catch(function (ex) { err.textContent = ex.message || A.strings.error; err.hidden = false; now.disabled = false; now.textContent = txt; });
        }
      });

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        err.hidden = true;
        addBtn.disabled = true;
        var prev = label.textContent;
        label.textContent = "Adding…";
        if (barBtn) barBtn.disabled = true;
        var ok = true;
        addToCart(idInput.value, qtyInput.value).catch(function (ex) {
          ok = false; err.textContent = ex.message || A.strings.error; err.hidden = false;
        }).then(function () {
          if (barBtn) barBtn.disabled = false;
          if (!ok || reduceMotion) { addBtn.disabled = false; label.textContent = prev; return; }
          label.textContent = "Added";
          addBtn.classList.add("is-added");
          setTimeout(function () { addBtn.classList.remove("is-added"); label.textContent = prev; addBtn.disabled = false; }, 1600);
        });
      });
    });
  }

  function initRecommendations(root) {
    $$("[data-recs]", root).forEach(function (el) {
      if (el.dataset.bound || !el.dataset.url) return;
      el.dataset.bound = "1";
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var next = $("[data-recs]", doc);
        if (next && next.innerHTML.trim()) { el.innerHTML = next.innerHTML; initReveal(el); initCarousels(el); applyWishlist(el); }
      }).catch(function () { /* recommendations are optional */ });
    });
  }

  /* ---------- Wishlist (saved in this browser) ---------- */
  function readWish() {
    try { return JSON.parse(localStorage.getItem("avern-wishlist") || "[]"); } catch (e) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem("avern-wishlist", JSON.stringify(list)); } catch (e) { /* storage blocked */ }
  }
  function applyWishlist(root) {
    var list = readWish();
    $$("[data-wishlist]", root).forEach(function (b) { b.setAttribute("aria-pressed", String(list.indexOf(b.dataset.wishlist) > -1)); });
  }
  function toggleWish(btn) {
    var list = readWish(), h = btn.dataset.wishlist, i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    writeWish(list);
    $$('[data-wishlist="' + h + '"]').forEach(function (b) { b.setAttribute("aria-pressed", String(i === -1)); });
    toast(i === -1 ? "Saved to your wishlist" : "Removed from your wishlist");
  }

  /* ---------- Filter drawer ---------- */
  var filtersFocus = null;
  function setFilters(open) {
    var f = $("#filters");
    if (!f || open === f.classList.contains("is-open")) return;
    f.classList.toggle("is-open", open);
    f.setAttribute("aria-hidden", String(!open));
    lockScroll(open);
    syncScrim();
    if (open) { filtersFocus = document.activeElement; var c = $("[data-filters-close]", f); if (c) c.focus(); }
    else if (filtersFocus) { filtersFocus.focus(); }
  }

  var filterTimer = null;
  function submitFilters(form) {
    $$("input", form).forEach(function (i) { if (i.type === "number" && !i.value) i.disabled = true; });
    form.submit();
  }

  /* ---------- Collection tools: grid size, sort, load more ---------- */
  function initCollection(root) {
    var grid = $("[data-grid]", root);
    if (!grid) return;
    var btns = $$("[data-density]", root);
    function apply(mode) {
      grid.classList.toggle("is-large", mode === "large");
      btns.forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.density === mode)); });
    }
    var saved = "small";
    try { saved = localStorage.getItem("avern-density") || "small"; } catch (e) { /* storage blocked */ }
    apply(saved);
    btns.forEach(function (b) {
      if (b.dataset.bound) return;
      b.dataset.bound = "1";
      b.addEventListener("click", function () {
        apply(b.dataset.density);
        try { localStorage.setItem("avern-density", b.dataset.density); } catch (e) { /* storage blocked */ }
      });
    });
  }

  function loadMore(link) {
    var more = link.closest("[data-more]"), grid = $("[data-grid]");
    if (!more || !grid) return;
    link.classList.add("is-loading");
    link.textContent = "Loading";
    fetch(link.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var nextGrid = $("[data-grid]", doc), nextMore = $("[data-more]", doc);
      if (!nextGrid) throw new Error("no grid");
      Array.prototype.slice.call(nextGrid.children).forEach(function (n) {
        if (n.classList.contains("c-interlude")) return;
        grid.appendChild(document.importNode(n, true));
      });
      if (nextMore) more.replaceChildren.apply(more, Array.prototype.slice.call(document.importNode(nextMore, true).childNodes));
      initReveal(grid);
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }).catch(function () { window.location.href = link.href; });
  }

  /* ---------- 3D model viewer (loads the library only when the tile is near the screen) ---------- */
  var modelScript = null;
  function loadModelViewer(src) {
    if (customElements.get("model-viewer")) return Promise.resolve();
    if (!modelScript) {
      modelScript = new Promise(function (resolve, reject) {
        var s = document.createElement("script");
        s.type = "module"; s.src = src; s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return modelScript.then(function () { return customElements.whenDefined("model-viewer"); });
  }

  function initModels(root) {
    var tiles = $$("[data-model-viewer]", root);
    if (!tiles.length) return;
    var coarse = window.matchMedia("(pointer: coarse)").matches;
    // The model may live in theme assets or in Content > Files: use whichever answers.
    function resolveSrc(mv) {
      var list = [mv.dataset.src, mv.dataset.altSrc].filter(Boolean);
      return (function next(i) {
        if (i >= list.length) return Promise.resolve(null);
        return fetch(list[i], { method: "HEAD" }).then(function (r) { return r.ok ? list[i] : next(i + 1); }).catch(function () { return next(i + 1); });
      })(0);
    }
    // If no copy of the model can be found, remove the empty tile instead of leaving a spinner.
    function dropTile(mv) {
      var tile = mv.closest("[data-model-tile]"), pdp = mv.closest("[data-product]");
      if (!tile || !pdp) return;
      tile.remove();
      var three = $(".pdp__thumb--3d", pdp);
      if (three) three.remove();
      $$("[data-thumb]", pdp).forEach(function (t, k) { t.dataset.thumb = k; });
      pdp.dispatchEvent(new Event("gallery:refresh"));
    }
    function start(mv) {
      if (mv.dataset.started) return;
      mv.dataset.started = "1";
      // Touch: the gallery must stay swipeable, so the model only rotates after a tap.
      mv.setAttribute("interaction-policy", coarse ? "allow-when-focused" : "always-allow");
      if (reduceMotion) mv.removeAttribute("auto-rotate");
      mv.addEventListener("load", function () { mv.closest("[data-model-tile]").classList.add("is-ready"); });
      mv.addEventListener("error", function () { dropTile(mv); });
      resolveSrc(mv).then(function (src) {
        if (!src) { dropTile(mv); return; }
        mv.setAttribute("src", src);
      });
    }
    tiles.forEach(function (mv) {
      if (mv.dataset.bound) return;
      mv.dataset.bound = "1";
      var go = function () { loadModelViewer(mv.dataset.viewerSrc).then(function () { start(mv); }).catch(function () { /* viewer is optional */ }); };
      if (!("IntersectionObserver" in window)) return go();
      var obs = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { obs.disconnect(); go(); }
      }, { rootMargin: "600px" });
      obs.observe(mv.closest("[data-model-tile]"));
    });
  }

  /* ---------- Product zoom viewer ---------- */
  var lb = null, lbIndex = 0, lbList = [], lbFocus = null, lbTouchX = null;
  function buildLightbox() {
    lb = document.createElement("div");
    lb.className = "lightbox";
    lb.setAttribute("role", "dialog");
    lb.setAttribute("aria-modal", "true");
    lb.setAttribute("aria-label", "Image viewer");
    lb.setAttribute("aria-hidden", "true");
    // Static markup only; no page or store data is interpolated here.
    lb.innerHTML =
      '<div class="lightbox__bar"><span data-lb-count></span>' +
      '<button type="button" class="lightbox__btn" data-lb-close aria-label="Close viewer"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M2 2l12 12M14 2 2 14" stroke-linecap="round"/></svg></button></div>' +
      '<button type="button" class="lightbox__btn lightbox__nav lightbox__nav--prev" data-lb-prev aria-label="Previous image"><svg viewBox="0 0 18 10" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M18 5H2M6 1 2 5l4 4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="lightbox__btn lightbox__nav lightbox__nav--next" data-lb-next aria-label="Next image"><svg viewBox="0 0 18 10" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M0 5h16M12 1l4 4-4 4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<div class="lightbox__stage"><img class="lightbox__img" alt="" draggable="false"></div>';
    document.body.appendChild(lb);
    var img = $(".lightbox__img", lb);
    img.addEventListener("click", function () { img.classList.toggle("is-zoomed"); });
    img.addEventListener("mousemove", function (e) {
      if (!img.classList.contains("is-zoomed")) return;
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
    });
    lb.addEventListener("touchstart", function (e) { lbTouchX = e.changedTouches[0].clientX; }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      if (lbTouchX === null) return;
      var dx = e.changedTouches[0].clientX - lbTouchX; lbTouchX = null;
      if (Math.abs(dx) > 50 && !img.classList.contains("is-zoomed")) lbShow(lbIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  function lbShow(i) {
    if (!lbList.length) return;
    lbIndex = (i + lbList.length) % lbList.length;
    var img = $(".lightbox__img", lb), fig = lbList[lbIndex];
    img.classList.remove("is-zoomed");
    img.style.transformOrigin = "";
    img.classList.add("is-swapping");
    setTimeout(function () {
      img.src = fig.dataset.zoomSrc;
      img.alt = fig.dataset.zoomAlt || "";
      img.onload = function () { img.classList.remove("is-swapping"); };
      if (img.complete) img.classList.remove("is-swapping");
    }, 160);
    $("[data-lb-count]", lb).textContent = (lbIndex + 1) + " / " + lbList.length;
    var multi = lbList.length > 1;
    $("[data-lb-prev]", lb).hidden = !multi; $("[data-lb-next]", lb).hidden = !multi;
    [lbIndex + 1, lbIndex - 1].forEach(function (n) {
      var f = lbList[(n + lbList.length) % lbList.length];
      if (f) { var p = new Image(); p.src = f.dataset.zoomSrc; }
    });
  }

  function openLightbox(figure) {
    if (!lb) buildLightbox();
    var pdp = figure.closest("[data-product]");
    lbList = $$("[data-zoom-src]", pdp);
    lbFocus = document.activeElement;
    lb.classList.add("is-open");
    lb.setAttribute("aria-hidden", "false");
    lockScroll(true);
    lbShow(lbList.indexOf(figure));
    $("[data-lb-close]", lb).focus();
  }

  function closeLightbox() {
    if (!lb || !lb.classList.contains("is-open")) return;
    lb.classList.remove("is-open");
    lb.setAttribute("aria-hidden", "true");
    lockScroll(false);
    if (lbFocus) lbFocus.focus();
  }

  /* ---------- Global wiring ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t.closest("[data-menu-open]")) return setMenu(true);
    if (t.closest("[data-menu-close]")) return setMenu(false);
    if (t.closest("#menu a")) return setMenu(false);
    if (t.closest("[data-search-open]")) return setSearch(true);
    if (t.closest("[data-search-close]")) return setSearch(false);
    if (t.closest("#search .search__popular a, #search .search__item")) return setSearch(false, true);
    if (t.closest("[data-cart-open]")) { e.preventDefault(); return setCart(true); }
    if (t.closest("[data-cart-close]")) return setCart(false);
    if (t.closest("[data-filters-open]")) return setFilters(true);
    if (t.closest("[data-filters-close]")) return setFilters(false);
    if (t === $("#scrim")) { setCart(false); setMenu(false); setSearch(false); setFilters(false); return; }

    var zoom = t.closest("[data-zoom-open]");
    if (zoom) { openLightbox(zoom.closest("[data-zoom-src]")); return; }
    if (lb && lb.classList.contains("is-open")) {
      if (t.closest("[data-lb-close]")) return closeLightbox();
      if (t.closest("[data-lb-prev]")) return lbShow(lbIndex - 1);
      if (t.closest("[data-lb-next]")) return lbShow(lbIndex + 1);
    }
    var more = t.closest("[data-more-link]");
    if (more) { e.preventDefault(); loadMore(more); return; }
    var wish = t.closest("[data-wishlist]");
    if (wish) { e.preventDefault(); toggleWish(wish); return; }

    var od = t.closest("[data-open-dialog]");
    if (od) { var dlg = document.getElementById(od.dataset.openDialog); if (dlg && dlg.showModal) dlg.showModal(); return; }
    var cd = t.closest("[data-close-dialog]");
    if (cd) { var d2 = cd.closest("dialog"); if (d2) d2.close(); return; }
    if (t.tagName === "DIALOG" && t.open) { t.close(); return; }

    var vp = t.closest("[data-variant-pick]");
    if (vp) {
      var radio = $('.pdp .opt[data-option-index="' + vp.dataset.variantPick + '"] input[value="' + (window.CSS && CSS.escape ? CSS.escape(vp.dataset.value) : vp.dataset.value) + '"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
        var top = $(".pdp");
        if (top) scrollToTarget(top);
      }
      return;
    }

    var qa = t.closest("[data-quick-add]");
    if (qa) {
      e.preventDefault();
      qa.disabled = true;
      addToCart(qa.dataset.quickAdd, 1).catch(function (ex) { toast(ex.message); }).then(function () { qa.disabled = false; });
      return;
    }
    if (t.closest("#cart, [data-cart-page]") && onCartLineAction(t)) return;

    var a = t.closest('a[href^="#"]');
    if (a && a.getAttribute("href").length > 1) {
      var target = document.getElementById(a.getAttribute("href").slice(1));
      if (target) {
        e.preventDefault();
        if (target.tagName === "DETAILS") target.open = true;
        scrollToTarget(target);
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (lb && lb.classList.contains("is-open")) {
      if (e.key === "Escape") closeLightbox();
      else if (e.key === "ArrowLeft") lbShow(lbIndex - 1);
      else if (e.key === "ArrowRight") lbShow(lbIndex + 1);
      return;
    }
    if (e.key === "Escape") {
      if ($("#filters.is-open")) setFilters(false);
      else if ($("#cart.is-open")) setCart(false);
      else if ($("#menu.is-open")) setMenu(false);
      else if ($("#search.is-open")) setSearch(false);
    }
    var open = $("#cart.is-open, #menu.is-open, #search.is-open, #filters.is-open");
    if (open) trapFocus(open, e);
  });

  document.addEventListener("input", function (e) {
    if (!e.target.matches("[data-search-input]")) return;
    var q = e.target.value.trim();
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { runSearch(q); }, 180);
  });

  document.addEventListener("change", function (e) {
    if (e.target.matches("[data-sort-select]")) {
      var u = new URL(window.location.href);
      u.searchParams.set("sort_by", e.target.value);
      u.searchParams.delete("page");
      window.location.href = u.toString();
      return;
    }
    var ff = e.target.closest("[data-filter-form]");
    if (ff) { clearTimeout(filterTimer); filterTimer = setTimeout(function () { submitFilters(ff); }, 400); }
  });

  window.addEventListener("scroll", refreshHeader, { passive: true });
  window.addEventListener("resize", refreshHeader);

  /* ---------- Header: hides on the way down, drops back on the way up ---------- */
  function initHeaderHide() {
    var header = $("[data-header]");
    if (!header || header.dataset.hideBound) return;
    header.dataset.hideBound = "1";
    var lastY = window.scrollY, ticking = false;
    function show() { body.classList.remove("header-hidden"); }
    function hide() { body.classList.add("header-hidden"); }
    function update() {
      ticking = false;
      var y = window.scrollY;
      if (body.classList.contains("is-locked")) { lastY = y; return; }
      var d = y - lastY;
      if (y < 90) show();
      else if (d > 8) hide();
      else if (d < -4) show();
      lastY = y;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    // Keyboard users tabbing into the header must always see it.
    header.addEventListener("focusin", show);
  }

  /* ---------- Text animation: headings rise word by word, copy fades up ---------- */
  var SPLIT_SEL = ".section-title, .title-serif, .title-sans, .pdpx__title, .c-head__title, .pdp__title, .page-head__title, .newsletter__title, .story__title, .split__title, .display";
  var FADE_SEL = ".eyebrow, .lede, .newsletter__text, .pdpx__muted, .pdp__short, .footer__tag, .c-head__text, .story__text";
  var textIO = null;

  function splitWords(el) {
    if (el.dataset.split) return;
    el.dataset.split = "1";
    var n = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement("span"), i = document.createElement("span");
            w.className = "w"; i.className = "wi";
            i.style.setProperty("--i", n++);
            i.textContent = part;
            w.appendChild(i); frag.appendChild(w);
          });
          node.replaceChild(frag, c);
        } else if (c.nodeType === 1 && c.tagName !== "BR" && !c.classList.contains("w")) {
          walk(c);
        }
      });
    })(el);
    el.classList.add("split-words");
  }

  function initTextAnimations(root) {
    var scope = root === document ? $$("main, footer") : [root];
    var targets = [];
    scope.forEach(function (s) {
      $$(SPLIT_SEL + ", " + FADE_SEL, s).forEach(function (el) {
        if (el.closest(".hero") || el.dataset.animBound) return;
        el.dataset.animBound = "1";
        targets.push(el);
      });
      if (s.matches && s.matches(SPLIT_SEL + ", " + FADE_SEL) && !s.dataset.animBound && !s.closest(".hero")) { s.dataset.animBound = "1"; targets.push(s); }
    });
    if (reduceMotion || !("IntersectionObserver" in window)) { return; }
    if (!textIO) {
      textIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("is-in"); textIO.unobserve(en.target); }
        });
      }, { rootMargin: "0px 0px -6% 0px", threshold: 0.15 });
    }
    targets.forEach(function (el) {
      if (el.matches(SPLIT_SEL)) splitWords(el); else el.classList.add("anim-fade");
      textIO.observe(el);
    });
  }

  /* ---------- Magnetic buttons (fine pointers only) ---------- */
  function initMagnetic() {
    if (reduceMotion || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    document.addEventListener("pointermove", function (e) {
      var b = e.target.closest && e.target.closest(".btn--gold, .btn--light, .btn:not(.btn--ghost):not(.btn--outline):not(.btn--sm)");
      if (!b || b.disabled) return;
      var r = b.getBoundingClientRect();
      var x = (e.clientX - (r.left + r.width / 2)) / r.width, y = (e.clientY - (r.top + r.height / 2)) / r.height;
      b.style.setProperty("--mx", (x * 8).toFixed(1) + "px");
      b.style.setProperty("--my", (y * 6).toFixed(1) + "px");
    }, { passive: true });
    document.addEventListener("pointerout", function (e) {
      var b = e.target.closest && e.target.closest(".btn");
      if (b) { b.style.removeProperty("--mx"); b.style.removeProperty("--my"); }
    }, { passive: true });
  }

  /* ---------- Boot ---------- */
  function boot(root) {
    initCarousels(root);
    initDots(root);
    initReveal(root);
    initProduct(root);
    initCollection(root);
    initModels(root);
    applyWishlist(root);
    initTextAnimations(root);
    initRecommendations(root);
    initParallax(root);
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  }

  function start() {
    window.__avernReady = true;
    initSmoothScroll();
    refreshHeader();
    initHeaderHide();
    initMagnetic();
    boot(document);
    document.documentElement.classList.add("split-ready");
    initHeroIntro();
    window.addEventListener("load", function () { if (window.ScrollTrigger) window.ScrollTrigger.refresh(); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  // Shopify theme editor: re-initialise sections as they are edited.
  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
    $$(".reveal, .split-words, .anim-fade", e.target).forEach(function (el) { el.classList.add("is-in"); });
    refreshHeader();
  });
})();
